import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./map-list-selector-dropdown.module.scss";
import {
	MapListDisplayType,
	mapListDisplayTypeToIcon,
} from "./map-list-display-type";
import InsetIcon from "../../../../elements/inset-icon";
import { mapMapListDisplayType } from "../../../../helper/language-helper";
import IconArrowDropDown from "../../../../dynamicicons/icon-arrow-drop-down";
import IconArrowDropUp from "../../../../dynamicicons/icon-arrow-drop-up";
import whitelabel from "../../../../whitelabel";

export interface MapListSelectorDropdownProps {
	displayType: MapListDisplayType;
	isOpen?: boolean;
	onClick?: () => void;
}

/**
 * The active dropdown component of the map list header menu
 */
export default function MapListDropdownSelector(
	props: MapListSelectorDropdownProps,
) {
	const { t } = useTranslation();
	return (
		<button className={styles.dropdown} onClick={props.onClick}>
			<InsetIcon icon={mapListDisplayTypeToIcon(props.displayType)} />
			<span className={styles.title}>
				{mapMapListDisplayType(props.displayType, t)}
			</span>
			{props.isOpen ? (
				<IconArrowDropUp color={whitelabel.palette.secondary900} />
			) : (
				<IconArrowDropDown color={whitelabel.palette.secondary900} />
			)}
		</button>
	);
}
